export const ActionLogs = {
  Category: "MerchantConsoleFrontend",
  Events: {
    ACCEPTED_PRIVACY_POLICY: "AcceptedPrivacyPolicy",
    ACCEPTED_TERMS_AND_CONDITIONS: "AcceptedTermsAndConditions",
    ACCEPTED_TERMS_AND_PRIVACY: "AcceptedTermsAndPrivacy",
    ACCEPT_PAYMENT_BUTTON_CLICKED: "AcceptPaymentButtonClicked",
    APPROVED_CUSTOMER: "ApprovedCustomer",
    CART_CREATED: "CartCreated",
    CART_MILESTONE_CREATED: "CartMilestoneCreated",
    CHATBOT_SUNSHINE_USER_AUTHENTICATED: "ChatBotSunshineUserAuthenticated",
    CHECK_FRAUD: "CheckFraud",
    CHECK_PJVERIFIED: "CheckPjVerified",
    CLERK_LOGIN_ATTEMPT: "ClerkLoginAttempt",
    CLERK_LOGIN_SUCCESS: "ClerkLoginSuccess",
    CLERK_LOGOUT: "ClerkLogout",
    CLERK_RESTARTED_SOFTWARE_INSTALLATION: "ClerkRestartedSoftwareInstallation",
    COLOMBIA_CUSTOMER_CONTACT_INFO_ENTERED:
      "ColombiaCustomerContactInfoEntered",
    CUSTOMER_CONTACT_INFO_ENTERED: "CustomerContactInfoEntered",
    CONTINUE_SELF_ONBOARDING_CART: "ContinueSelfOnboardingCart",
    DEVICE_TAG_SCREENLOADED: "DeviceTagScreenLoaded",
    DEVICE_TAG_ENTERED: "DeviceTagEntered",
    DEVICE_TAG_ERRORS: "DeviceTagErrors",
    DEVICE_ACTIVATION_STATUS: "DeviceActivationStatus",
    FINANCE_ORDER_CREATED: "FinanceOrderCreated",
    RECEIPT_LOADED: "ReceiptLoaded",
    CLERK_PROVIDED_FEEDBACK_WITH_STARS: "ClerkProvidedFeedbackWithStars",
    CLERK_SUBMITTED_FEEDBACK: "ClerkSubmittedFeedback",
    CONTRACT_CAN_BE_SIGNED: "ContractCanBeSigned",
    CONTRACT_CAN_CONTINUE_NEXT_STEP: "ContractCanContinueNextStep",
    CONTRACT_CAN_NOT_CONTINUE_NEXT_STEP: "ContractCanNotContinueNextStep",
    CUSTOMER_ENTERED_VALID_PHONE: "CustomerEnteredValidPhoneNumber",
    CUSTOMER_ENTERED_A_PIN_TO_VERIFY_THEIR_PHONE:
      "CustomerEnteredAPinToVerifyTheirPhone",
    CUSTOMER_PHONE_WAS_FILLED_IN_AND_VERIFIED:
      "CustomerPhoneWasFilledInAndVerified",
    CONTRACT_SIGNING: "ContractSigning",
    CONTRACT_VERBAL_STATUS_CHANGE: "ContractVerbalStatusChange",
    CUSTOMER_ASSISTANCE: "CustomerAssistance",
    OTHER_UPLOAD_OPTION: "OtherUploadOptions",
    CUSTOMER_ADDRESS_ENTERED: "CustomerAddressEntered",
    CUSTOMER_NEIGHBORNHOOD_ENTERED: "CustomerNeighborhoodEntered",
    CUSTOMER_ADRESS_FIELDS_SAVED: "CustomerAddressFieldsSaved",
    TRANSCRIBE_ID_REQUESTED: "TranscribeIdRequested",
    TRANSCRIBE_ID_SUCCESSFUL: "TranscribeIdSuccessful",
    CX_VALIDATION: "CxValidation",
    DECLINED_VALIDATION: "declinedValidation",
    ENABLE_SELF_SERVED_BUTTON_CLICKED: "EnableSelfServedButtonClicked",
    ENABLE_IMAGE_UPLOAD: "EnableImageUploadPage",
    FINISH_SALE_BUTTON_CLICKED: "FinishSaleButtonClicked",
    FORGOT_PASSWORD_BUTTON_CLICKED: "ForgotPasswordButtonClicked",
    GET_MY_PHONE_BUTTON_CLICKED: "GetMyPhoneButtonClicked",
    ID_BACK_UPLOADED: "IdBackUploaded",
    ID_BACK_UPLOAD_ATTEMPT: "IdBackUploadAttempt",
    ID_FRONT_UPLOADED: "IdFrontUploaded",
    ID_FRONT_UPLOAD_ATTEMPT: "IdFrontUploadAttempt",
    ID_PROOF_OF_ADDRESS_UPLOADED: "IdProofOfAddressUploaded",
    ID_PROOF_OF_UPLOAD_ATTEMPT: "IdProofOfAddressUploadAttempt",
    ID_REGISTRATION_DONE: "IdRegistrationDone",
    ID_SELFIE_UPLOADED: "IdSelfieUploaded",
    ID_SELFIE_UPLOAD_ATTEMPT: "IdSelfieUploadAttempt",
    IMAGE_UPLOAD_PAGE_OPENED: "ImageUploadPageOpened",
    IMAGE_UPLOAD_SUBMIT_CLICKED: "ImageUploadSubmitClicked",
    INCODE_FINISHED_IMPORT: "IncodeFinishedImport",
    INCODE_ONBOARD: "IncodeOnboard",
    INCODE_START_IMPORT: "IncodeStartImport",
    INCODE_STATUS: "IncodeStatus",
    INCODE_UUID_UPDATED: "IncodeUuidUpdated",
    NUM_LOADED_MANUFACTURERS: "NumLoadedManufacturers",
    NUM_LOADED_DEVICE_FAMILIES: "NumLoadedDeviceFamilies",
    NUM_LOADED_DEVICE_MODELS: "NumLoadedDeviceModels",
    RETAIL_PRICE_ERROR: "RetailPriceError",
    DOWM_PAYMENT_ERROR: "DownPaymentError",
    RETAIL_PRICE_EDITABLE: "RetailPriceEditable",
    TERMS_LOADED: "TermsLoaded",
    CLERK_SELECTED_OFFER: "ClerkSelectedOffer",

    // OBR PAGE
    OBR_DEVICES_LIST: "ObrDevicesList",
    OBR_BRAND_FILTER_CLICKED: "ObrBrandFilterClicked",
    OBR_DEVICE_SELECTED: "ObrDeviceSelected",
    OBR_TERM_SELECTED: "ObrTermSelected",
    OBR_CONTINUE_BUTTON_CLICKED: "ObrContinueButtonClicked",
    OBR_SKIP_BUTTON_CLICKED: "ObrSkipButtonClicked",

    OFFERS_CONTINUE_BUTTON: "OffersContinueButton",
    INSTORE_PAYMENT_CUSTOMER_PAID: "InstorePaymentCustomerPaid",
    INSTORE_PAYMENT_DEVICE_LOOKUP_ATTEMPT: "InstorePaymentDeviceLookupAttempt",
    INSTORE_PAYMENT_DEVICE_LOOKUP_SUCCESS: "InstorePaymentDeviceLookupSuccess",
    MERCHANT_LOGIN_ATTEMPT: "MerchantLoginAttempt",
    MERCHANT_LOGIN_SUCCESS: "MerchantLoginSuccess",
    ORDER_SUBMIT: "orderSubmit",
    PASSED_WELCOME_CALL_VALIDATION: "ContractPassedWelcomeCallValidation",
    PHOTO_UPLOADED: "PhotoUploaded",
    PP_LOADED_BY_DROPDOWN_CLICK: "PPLoadedByDropdownClick",
    PRICING_CAN_CONTINUE_NEXT_STEP: "PricingCanContinueNextStep",
    PRICING_ELIGIBILITY_RESULT: "PricingEligibilityResult",
    PRICING_SET_DEVICE: "PricingSetDevice",
    PRICING_SET_DOWNPAYMENT: "PricingSetDownPayment",
    PRICING_SET_FAMILY: "PricingSetFamily",
    PRICING_SET_MANUFACTURER: "PricingSetManufacturer",
    PRICING_SET_RETAIL_PRICE: "PricingSetRetailPrice",
    PRICING_VALID_DOWNPAYMENT: "PricingValidDownPayment",
    PRICING_VALID_DOWNPAYMENT_AND_TERM: "PricingValidDownPaymentAndTerm",
    DOWNPAYMENT_REDUCTION_MESSAGE: "DownpaymentReductionMessage",
    PRIVACY_POLICY_CHECKBOX_CHECKED: "PrivacyPolicyCheckboxChecked",
    PRIVACY_POLICY_LOADED: "PrivacyPolicyLoaded",
    REACHED_SELF_ONBOARDING_SUMMARY: "ReachedSelfOnboardingSummary",
    RESET_PASSWORD_BUTTON_CLICKED: "ResetPasswordButtonClicked",
    RESET_VALIDATION: "resetValidation",
    RESET_VALIDATION_FAILED: "resetValidationFailed",
    SEARCH_SELF_ONBOARDING_CART: "SearchSelfOnboardingCart",
    SELF_SERVICE_SURVEY_USE: "SelfServiceSurveyUse",
    SELF_SERVICE_SURVEY_SKIP: "SelfServiceSurveySkip",
    SELL_PHONE_BUTTON_CLICKED: "SellPhoneButtonClicked",
    SEND_LATEST_CART: "SendLatestCart",
    SESSION_EXPIRED: "SessionExpired",
    SOFTWARE_INSTALL_PAGE: "SoftwareInstallPage",
    SOFTWARE_INSTALL_WIZARD: "SoftwareInstallWizard",
    DEVICE_PHONE_ENTERED: "DevicePhoneEntered",
    CUSTOMER_CART_PREVIEW: "CustomerCartPreview",
    QR_CODE_SOFTWARE_FLOW: "QrcodeSoftwareFlow",
    IMEI_SOFTWARE_FLOW: "IMEISoftwareFlow",
    SIDE_LOAD_SOFTWARE_FLOW: "SideLoadSoftwareFlow",
    DLC_SOFTWARE_FLOW: "DLCSoftwareFlow",
    SKIPPED_SOFTWARE_INSTRUCTIONS: "skippedSoftwareInstructions",
    TC_LOADED_BY_DROPDOWN_CLICK: "TCLoadedByDropdownClick",
    TERMS_AND_CONDITIONS_CHECKBOX_CHECKED: "TermsAndConditionsCheckboxChecked",
    TERMS_AND_CONDITIONS_LOADED: "TermsAndConditionsLoaded",
    TERM_OPTIONS_LOWER_WEEKLY_PAYMENT_BADGES:
      "TermOptionsLowerWeeklyPaymentBadges",
    TERM_OPTIONS_NO_PAYMENT_BADGE: "TermOptionsNoPaymentBadge",
    TERM_OPTIONS_MONTH_TERM_POPULARITY_BADGES:
      "TermOptionsMonthTermPopularityBadges",
    TERM_OPTIONS_LOWEST_TOTAL_PAYMENT_BADGE:
      "TermOptionsLowestTotalPaymentBadge",
    RECOM_OFFERS_DISPLAYED: "recommendedOffersDisplayed",
    RECOM_OFFERS_CLICKED: "recommendedOffersClicked",
    TERM_OPTIONS_LOWER_WEEKLY_PAYMENT_BADGES_CLICKED:
      "TermOptionsLowerWeeklyPaymentBadgesClicked",
    TERM_OPTIONS_MONTH_TERM_POPULARITY_BADGES_CLICKED:
      "TermOptionsMonthTermPopularityBadgesClicked",
    TERM_OPTIONS_LOWEST_TOTAL_PAYMENT_BADGE_CLICKED:
      "TermOptionsLowestTotalPaymentBadgeClicked",
    UNAUTHORIZED_PAGE: "UnauthorizedPage",

    REQUESTED_CX_CALL: "RequestedCxCall",
    ANSWERED_CX_CALL: "AnsweredCall",

    //QR Login
    QR_LOGIN_DETECT_MOBILE: "QrLoginDetectMobile",
    CHECK_CLERK_SESSION_STATUS: "CheckClerkSessionStatus",
    LOGIN_QR_CODE_DISPLAYED: "LoginQrCodeDisplayed",
    QR_LOGIN_SESSION_AUTHENTICATED: "QrLoginSessionAuthenticated",
    QR_LOGIN_SESSION_CX_REJECTED: "QrLoginSessionCxRejected",
    QR_LOGIN_SESSION_CX_APPROVED: "QrLoginSessionCxApproved",
    ERROR_QR_LOGIN_SESSION_EXPIRED: "ErrorQrLoginSessionExpired",
    QR_LOGIN_SHOW_LOGIN_INTRO: "QrLoginShowLoginIntro",
    QR_LOGIN_SHOW_SUCCESS_LOGIN: "QrLoginShowSuccessLogin",
    QR_LOGIN_SHOW_TAKE_SELFIE_INTRO: "QrLoginShowTakeSelfieIntro",
    QR_LOGIN_GO_TO_FACE_LOGIN: "QrLoginGoToFaceLogin",
    QR_LOGIN_INCODE_CAPTURE_VIEW: "QrLoginIncodeCaptureView",
    QR_LOGIN_INCODE_CAPTURE_SUCCESS: "QrLoginIncodeCaptureSuccess",
    QR_LOGIN_INCODE_CAPTURE_FACEMATCH_REJECTED:
      "QrLoginIncodeCaptureFacematchRejected",
    QR_LOGIN_INCODE_CAPTURE_RETRY: "QrLoginIncodeCaptureRetry",
    QR_LOGIN_SHOW_INCODE_CAPTURE: "QrLoginShowIncodeCapture",
    QR_LOGIN_DISPLAY_CX_REVIEWING_PAGE: "QrLoginDisplayCxReviewingPage",
    SHOW_CLERK_REGISTRATION: "QrLoginShowClerkRegistration",
    SUBMITTED_CLERK_REGISTRATION: "QrLoginSubmittedClerkRegistration",
    SUBMIT_CLERK_REGISTRATION_ERROR: "QrLoginSubmitClerkRegistrationError",
    QR_LOGIN_INCODE_CAPTURE_FACEMATCH_APPROVED:
      "QrLoginIncodeCaptureFacematchApproved",
    QR_LOGIN_SESSION_CREATED: "QrLoginSessionCreated",
    QR_LOGIN_SESSION_ERROR: "QrLoginSessionError",
    VALIDATE_STORED_JWT: "ValidateStoredJwt",
    ERROR_VALIDATE_STORED_JWT: "ErrorValidateStoredJwt",
    CLERK_SIGN_IN: "ClerkSignIn",
    CLERK_SIGN_IN_ERROR: "ClerkSignInError",
    CLERK_AUTH_IDENTITY: "ClerkAuthIdentity",
    CLERK_AUTH_IDENTITY_ERROR: "ClerkAuthIdentityError",
    CLERK_SIGN_ERROR: "ClerkSignError",
    QR_LOGIN_CLERK_AUTHENTICATED: "QrLoginClerkAuthenticated",

    // SUSPICIOUS ACTIVITY
    SUSPICIOUS_ACTIVITY: "SuspiciousActivity",
    SUSPICIOUS_ACTIVITY_POST_FAIL: "SuspiciousActivityPostFail",
  },
};

export interface IActionLogDataObject {
  merchantId?: string;
  clerkId?: string;
  cartId?: string;
  userId?: string;
}
export default ActionLogs;
